import type { EntityViewCard, MetadataEntityFieldData } from '@jms/model';
import type { CardFieldOptions } from '../../state/features/with.metadata';

function firstPath(fields: MetadataEntityFieldData[]): string | undefined {

  return fields[0]?.path ?? undefined;
}

/**
 * Compact card when the view has no card2. Header slots only — never every metadata field as body rows.
 */
export function buildFallbackCardConfig(cardFields: CardFieldOptions): Partial<EntityViewCard> | null {

  const identifier = firstPath(cardFields.identifier);
  const title = cardFields.title.map(field => field.path).find((path): path is string => !!path && path !== identifier);
  const status = firstPath(cardFields.status);
  const footer = firstPath(cardFields.footer);
  const footerPaths = footer && footer !== status ? [footer] : [];

  if (!identifier && !title && !status && !footerPaths.length) return null;

  return { identifier, title, description: null, status, body: [], footer: footerPaths };
}
